// Component to change sort order or filters for displaying jobs in current schedule
import { useSchedulerContext } from '@/context/SchedulerContext';

import SchedulerFilter from '@/components/Scheduler/SchedulerDays/SchedulerOptions/SchedulerFilter';
import SchedulerInfo from '@/components/Scheduler/SchedulerDays/SchedulerOptions/SchedulerInfo';
import SchedulerSort from '@/components/Scheduler/SchedulerDays/SchedulerOptions/SchedulerSort';
import SchedulerViewSwitch from '@/components/Scheduler/SchedulerDays/SchedulerOptions/SchedulerViewSwitch';
import ShowOperatorsToggle from '@/components/Scheduler/SchedulerDays/SchedulerOptions/ShowOperatorsToggle';

export default function SchedulerOptions() {
  const { schedulerView } = useSchedulerContext();
  const isListView = schedulerView === 'list';
  return (
    <div className="scheduler-options flex h-full justify-end gap-4">
      <SchedulerViewSwitch />
      {/* Show Operators and the sort order only affect the Jobs list; filters
          apply to both the list and the map */}
      {isListView && <ShowOperatorsToggle />}
      <SchedulerFilter />
      {isListView && <SchedulerSort />}
      <SchedulerInfo />
    </div>
  );
}
